/** PC 门户列表页 url，小程序 H5 映射为 HoreList */
export const H5_LIST_MENU_URL = 'tableform/Tableform'

export function isH5ListMenuUrl(url) {
  const normalized = String(url || '').replace(/\\/g, '/').trim()
  return normalized === H5_LIST_MENU_URL || normalized.endsWith('/' + H5_LIST_MENU_URL)
}

export function resolveH5MenuComponent(url) {
  if (isH5ListMenuUrl(url)) {
    return () => import('@/views/h_list/HoreList')
  }
  return () => import(`@/views/${url}`)
}

export function buildH5RouteMeta(meta, url) {
  const next = { ...(meta || {}), pageType: 'h5' }
  if (isH5ListMenuUrl(url)) {
    next.hideTabBar = true
  }
  return next
}
